import { render, staticRenderFns } from "./AcoesExcluir.vue?vue&type=template&id=4c096a06&scoped=true"
import script from "./AcoesExcluir.vue?vue&type=script&lang=js"
export * from "./AcoesExcluir.vue?vue&type=script&lang=js"
import style0 from "./AcoesExcluir.vue?vue&type=style&index=0&id=4c096a06&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c096a06",
  null
  
)

export default component.exports